"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Mixins, Ref, PropSync } from "vue-property-decorator";
import LayoutHeader from "./LayoutHeader.vue";
import API from "@ym-framework/api-utils";
import ConfirmInfo from "@/views/giftsItems/ConfirmInfo.vue";
import { AccountSessionMixins } from "@/service/account-session";
import Gift from "@/views/giftsItems/Gift.vue";
import NewCreateSafeEnvDialog from "@/views/virtualdesktopItems/components/dialog-forms/NewCreateSafeEnvDialog.vue";
import CreateSafeSuccessDialog from "@/views/virtualdesktopItems/components/dialog-forms/CreateSafeSuccessDialog.vue";
import { DashboardClientModel } from "@/models/DashboardClient.model";
import SetPasswordDialog from "@/views/virtualdesktopItems/components/dialog-forms/SetPasswordDialog.vue";
import Cookies from "js-cookie";
import { WebsocketViewService } from "@/utils/webSocketViewService";
import RenewVDDialog from "./components/dialog/RenewVDDialog.vue";
import QuestionPageDialog from "@/views/QuestionPageDialog.vue";
export class LayoutUI {
  static component() {
    return this._component;
  }
  static init(component) {
    this._component = component;
  }
  static showDrawer(position) {
    if (position) {
      this._component._controller.direction = position;
    }
    this._component._controller.visible = true;
  }
}
LayoutUI._component = null;
export class DrawerUI {
  static component() {
    return this._component;
  }
  static init(component) {
    this._component = component;
  }
}
DrawerUI._component = null;
export class UiDrawerController {
  constructor(visible, direction) {
    this._visible = false;
    this._direction = "rtl";
    this._visible = visible;
    this._direction = direction;
  }
  set visible(visible) {
    this._visible = visible;
  }
  get visible() {
    return this._visible;
  }
  set direction(direction) {
    this._direction = direction;
  }
  get direction() {
    return this._direction;
  }
}
let Layout = class extends Mixins(AccountSessionMixins) {
  constructor() {
    super(...arguments);
    // @Ref('noviceChooseTeamDialog') _noviceChooseTeamDialog!:NoviceChooseTeamDialog
    //dashboard信息
    this.main_info = new DashboardClientModel();
    //是否展示过期金豆提示
    this.show_coin_alert = false;
    //是否展示过期优惠券提示
    this.show_coupon_alert = false;
    //是否展示未支付订单提示
    this.show_unpaid_order = false;
    //是否展示续费提示
    this.shop_renew = false;
    //是否显示过了设置密码的提示
    this.show_set_password_alert = false;
    //过期优惠券数量
    this.expire_coupons = 0;
    //过期金豆数量
    this.expire_coins = 0;
    //websocket服务
    this.webSocketService = WebsocketViewService;
    //未确认订单
    this.unchecked_orders = [];
  }
  mounted() {
    return __async(this, null, function* () {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      this.webSocketService._ipcEvent.on(
        "event:teamChange.refresh.page",
        (data) => __async(this, null, function* () {
          location.replace(location.href);
        })
      );
      if (localStorage.getItem("set_password") && localStorage.getItem("set_password") === "true") {
        this.show_set_password_alert = true;
      }
      yield this.showUnpaid();
      yield this.showUnchecked();
      yield this.checkJoinTeam();
      yield this.getVDRenewInfo();
      if (((_a = this.$session) == null ? void 0 : _a.type) === "account") {
      }
      if (this.$route.query.hasOwnProperty("activity") && this.$route.query.hasOwnProperty("activity") !== null) {
        let _item = this.$route.query.activity;
        try {
          yield API.get(
            `api://base.local/storages/users/${this.$session.id}/preference/novice`
          );
          let _data = JSON.parse(_item);
          this._confirm_info.opendialog(_data);
        } catch (error) {
          if ((_b = this.$session) == null ? void 0 : _b.marks.is("NOVICE_GUIDE")) {
            try {
              this._create_safe_env_dialog.open();
              yield API.put(
                `api://base.local/storages/users/${(_c = this.$session) == null ? void 0 : _c.id}/preference/novice`,
                {
                  flag: true
                }
              );
            } catch (error2) {
              console.log(error2);
            }
          } else {
            yield API.put(
              `api://base.local/storages/users/${(_d = this.$session) == null ? void 0 : _d.id}/preference/novice`,
              {
                flag: true
              }
            );
          }
        }
      } else {
        try {
          yield this._giftController.checkDialog();
        } catch (error) {
        }
        try {
          yield API.get(
            `api://base.local/storages/users/${this.$session.id}/preference/novice`
          );
        } catch (error) {
          if ((_e = this.$session) == null ? void 0 : _e.marks.is("NOVICE_GUIDE")) {
            try {
              this._create_safe_env_dialog.open();
              yield API.put(
                `api://base.local/storages/users/${(_f = this.$session) == null ? void 0 : _f.id}/preference/novice`,
                {
                  flag: true
                }
              );
            } catch (error2) {
              console.log(error2);
            }
          } else {
            yield API.put(
              `api://base.local/storages/users/${(_g = this.$session) == null ? void 0 : _g.id}/preference/novice`,
              {
                flag: true
              }
            );
          }
        }
      }
      if (localStorage.getItem("openEnvDialog") !== null && localStorage.getItem("openEnvDialog") !== "") {
        localStorage.removeItem("openEnvDialog");
        this._create_safe_env_dialog.open();
        yield API.put(
          `api://base.local/storages/users/${(_h = this.$session) == null ? void 0 : _h.id}/preference/novice`,
          {
            flag: true
          }
        );
      }
      if (localStorage.getItem("recommand") !== null && localStorage.getItem("recommand") !== "") {
        let _vd_info = localStorage.getItem("recommand");
        localStorage.removeItem("recommand");
        this._create_safe_success_dialog.open(_vd_info);
      }
    });
  }
  created() {
    return __async(this, null, function* () {
      LayoutUI.init(this);
      DrawerUI.init(this.drawerElement);
      yield this.getMainInfo();
    });
  }
  refreshPage() {
    location.replace(location.href);
  }
  // 获取设备到期提醒信息
  getVDRenewInfo() {
    return __async(this, null, function* () {
      try {
        if (this.$session.type === "account") {
          let response = yield API.get(`api://base.auth/api/v1/vd-renew-alert`);
          let items = response.data.vds;
          if (items !== null && items.length > 0) {
            try {
              let result = yield API.get(
                `api://base.local/storages/users/${this.$session.id}/preference/renew_tip_date`
              );
              let date = result.data.value.date;
              let tip = result.data.value.tip;
              if (date <= Date.now()) {
                this._renew_vd_dialog.open(items, this.$session.id, tip);
                yield API.delete(
                  `api://base.local/storages/users/${this.$session.id}/preference/renew_tip_date`
                );
              }
            } catch (error) {
              this._renew_vd_dialog.open(items, this.$session.id);
            }
          }
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 检测打开加入团队提示弹窗
  checkJoinTeam() {
    return __async(this, null, function* () {
      try {
        let data = localStorage.getItem("showJoinTeamMessage");
        if (data && data === "true") {
          localStorage.removeItem("showJoinTeamMessage");
          yield this.$confirm(
            `${this.$t("teamJoin.tip_content")}`,
            this.$t("teamJoin.confirm_title"),
            {
              roundButton: true,
              showCancelButton: false,
              dangerouslyUseHTMLString: true,
              confirmButtonText: `${this.$t("teamJoin.confirm_button")}`
            }
          );
        }
      } catch (error) {
      }
    });
  }
  //打开设置密码弹窗
  toSetPassword_btn() {
    return __async(this, null, function* () {
      this._set_password_dialog.open();
    });
  }
  //去续费
  toRenew_btn() {
    this.$emit("toRenew");
  }
  //去支付
  clickToUseCoupon() {
    this.$router.push("/payment?style=create");
  }
  //获取dashboard信息
  getMainInfo() {
    return __async(this, null, function* () {
      if (this.$session.type === "account" || this.$session.permissions.is("SHOW_ALL_MENUS")) {
        let response = yield API.get(`api://base.auth.pro/v1/accounts/dashboard`);
        this.main_info = response.data;
        const _renew = Cookies.get("renew");
        if (_renew !== "true") {
          setTimeout(() => {
            this.shop_renew = true;
          }, 1e3);
          setTimeout(() => {
            this.shop_renew = false;
          }, 6e3);
        } else {
          this.shop_renew = false;
        }
        yield this.getCoinDate();
        yield this.getCouponsTip();
      }
    });
  }
  // 获取未支付订单数据信息
  showUnpaid() {
    return __async(this, null, function* () {
      try {
        if (this.$session.type === "account" || this.$session.permissions.is("SHOW_ALL_MENUS")) {
          let response = yield API.get(
            `api://base.auth.pro/v1/orders/unpaid-count`
          );
          if (response.data.count > 0) {
            const _order = Cookies.get("order");
            if (_order !== "true") {
              setTimeout(() => {
                this.show_unpaid_order = true;
              }, 1e3);
              setTimeout(() => {
                this.show_unpaid_order = false;
              }, 6e3);
            } else {
              this.show_unpaid_order = false;
            }
          }
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  // 获取未确认订单数据信息
  showUnchecked() {
    return __async(this, null, function* () {
      try {
        if (this.$session.type === "account" || this.$session.permissions.is("SHOW_ALL_MENUS")) {
          let response = yield API.get(
            `api://base.auth.pro/v1/orders/paypal/unconfirm`
          );
          let ids = response.data.datas;
          if (ids.length) {
            ids.forEach((item) => {
              item.show_order = Cookies.get(`unchecked_${item.id}`) !== "true";
            });
          }
          this.unchecked_orders = ids;
        }
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  //获取金豆过期信息
  getCoinDate() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(`api://base.auth/api/v7/coins/overdue`);
        if (response.data.coins > 0) {
          const _coin = Cookies.get("coin");
          if (_coin !== "true") {
            setTimeout(() => {
              this.show_coin_alert = true;
            }, 1e3);
            this.expire_coins = response.data.coins;
            setTimeout(() => {
              this.show_coin_alert = false;
            }, 6e3);
          } else {
            this.show_coin_alert = false;
          }
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  //去订单页
  toViewOrder_btn() {
    this.$router.push("/cost#OrderManage");
  }
  //去支付
  toPayOrder_btn(order) {
    let style = "";
    if (order.type === "new") {
      style = "create";
    } else if (order.type === "renew") {
      style = "renew";
    } else if (order.type === "upgrade") {
      style = "update";
    }
    this.$router.push({
      name: "PaymentConfirmation",
      query: {
        t: "paypal",
        // r:this.recommand_top_category,
        r: "",
        id: order.id,
        // qr:_qr_url,
        qr: "",
        gift: order.money <= 0,
        style
      }
    });
  }
  //不再提醒
  noMoreAlert(tip, id) {
    const exp = new Date();
    const nowTime = 86400 - (exp.getHours() * 60 * 60 + exp.getMinutes() * 60 + exp.getSeconds());
    exp.setTime(exp.getTime() + nowTime * 1e3);
    if (tip === "unchecked") {
      this.unchecked_orders.find((item) => {
        return item.id === id;
      }).show_order = false;
      Cookies.set(`${tip}_${id}`, "true", { expires: exp });
      return;
    }
    Cookies.set(tip, "true", { expires: exp });
    if (tip === "renew") {
      this.shop_renew = false;
    }
    if (tip === "coin") {
      this.show_coin_alert = false;
    }
    if (tip === "coupon") {
      this.show_coupon_alert = false;
    }
    if (tip === "order") {
      this.show_unpaid_order = false;
    }
  }
  //获取优惠券过期信息提示
  getCouponsTip() {
    return __async(this, null, function* () {
      try {
        let response = yield API.get(
          `api://base.auth/api/v7/discount-coupon/overdue`
        );
        if (response.data.overdueCoupon) {
          const _coupon = Cookies.get("coupon");
          if (_coupon !== "true") {
            setTimeout(() => {
              this.show_coupon_alert = response.data.overdueCoupon;
            }, 1e3);
            this.expire_coupons = response.data.count;
            setTimeout(() => {
              this.show_coupon_alert = false;
            }, 6e3);
          } else {
            this.show_coupon_alert = false;
          }
        }
      } catch (error) {
        console.log(error);
      }
    });
  }
  resetUserGuide() {
    return __async(this, null, function* () {
      var _a;
      try {
        yield API.put(
          `api://base.local/storages/users/${(_a = this.$session) == null ? void 0 : _a.id}/preference/novice`,
          {
            flag: true
          }
        );
      } catch (error) {
      }
    });
  }
  //关闭广告弹窗
  closeConfirm() {
    return __async(this, null, function* () {
      var _a, _b, _c;
      try {
        yield API.get(
          `api://base.local/storages/users/${this.$session.id}/preference/novice`
        );
        yield this._giftController.checkDialog();
      } catch (error) {
        if ((_a = this.$session) == null ? void 0 : _a.marks.is("NOVICE_GUIDE")) {
          this._create_safe_env_dialog.open();
          yield API.put(
            `api://base.local/storages/users/${(_b = this.$session) == null ? void 0 : _b.id}/preference/novice`,
            {
              flag: true
            }
          );
        } else {
          yield API.put(
            `api://base.local/storages/users/${(_c = this.$session) == null ? void 0 : _c.id}/preference/novice`,
            {
              flag: true
            }
          );
        }
      }
    });
  }
  //销毁websocket
  beforeDestroy() {
    this.webSocketService._ipcEvent.removeAllListeners();
  }
};
__decorateClass([
  Ref("drawer-element")
], Layout.prototype, "drawerElement", 2);
__decorateClass([
  Ref("confirm_info")
], Layout.prototype, "_confirm_info", 2);
__decorateClass([
  Ref("gift_controller")
], Layout.prototype, "_giftController", 2);
__decorateClass([
  Ref("safe-dialog")
], Layout.prototype, "_create_safe_env_dialog", 2);
__decorateClass([
  Ref("create-safe-success-dialog")
], Layout.prototype, "_create_safe_success_dialog", 2);
__decorateClass([
  Ref("set_password_dialog")
], Layout.prototype, "_set_password_dialog", 2);
__decorateClass([
  Ref("renew_vd_dialog")
], Layout.prototype, "_renew_vd_dialog", 2);
__decorateClass([
  Ref("questionPageDialog")
], Layout.prototype, "_question_page_dialog", 2);
__decorateClass([
  PropSync("controller", {
    type: UiDrawerController,
    default: () => {
      return new UiDrawerController(false, "rtl");
    }
  })
], Layout.prototype, "_controller", 2);
Layout = __decorateClass([
  Component({
    components: {
      NewCreateSafeEnvDialog,
      LayoutHeader,
      ConfirmInfo,
      Gift,
      CreateSafeSuccessDialog,
      SetPasswordDialog,
      RenewVDDialog,
      QuestionPageDialog
      // NoviceChooseTeamDialog
    }
  })
], Layout);
export {
  Layout as default
};
